import Service from "../../service";

const Vendor = {
    getVendor(page) {
        return Service.get("/vendor?page="+page);
    },
    getVendorAll(){
       return Service.get("/vendor-all");
    },
    showVendor(id) {
        return Service.get("/vendor/" + id);
    },
    createVendor(data){
        return Service.post('/vendor' ,data);
    },
    updateVendor(id,data){
        return Service.put('/vendor/'+id,data);
    },
    deleteVendor(id){
      return Service.delete('/vendor/'+id);
    },
    searchVendor(data){
        return Service.post('/search-vendor?page='+data.page,data);
    }
};

export default Vendor;
